import { useState } from 'react';
import { supabase } from '@/lib/supabase';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [msg, setMsg] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setStatus('idle');
    const { error } = await supabase.from('newsletter_subscribers').insert({ email, name });
    if (error) {
      if (error.code === '23505') {
        setMsg('You are already subscribed!');
        setStatus('success');
      } else {
        setMsg('Something went wrong. Please try again.');
        setStatus('error');
      }
    } else {
      setMsg('You\'re subscribed! Welcome to AiShopio.');
      setStatus('success');
      setEmail('');
      setName('');
    }
    setLoading(false);
  };

  return (
    <section className="py-20 px-6 bg-gradient-to-r from-orange-500 to-pink-600 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 left-10 w-40 h-40 bg-white rounded-full"></div>
        <div className="absolute bottom-10 right-10 w-60 h-60 bg-white rounded-full"></div>
      </div>
      <div className="max-w-2xl mx-auto text-center relative z-10">
        <span className="inline-block bg-white/20 text-white text-xs font-semibold px-4 py-1.5 rounded-full mb-4">Newsletter</span>
        <h2 className="text-3xl md:text-4xl font-black text-white mb-3">Get Exclusive Dubai Deals</h2>
        <p className="text-white/80 mb-8 text-sm">Subscribe for early access to sales, new arrivals & special AED offers delivered to your inbox.</p>
        {status === 'success' ? (
          <div className="bg-white/20 backdrop-blur-sm rounded-2xl p-6 text-white">
            <i className="ri-checkbox-circle-line text-4xl mb-2 block"></i>
            <p className="font-semibold">{msg}</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3">
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Your name"
              required
              className="flex-1 px-5 py-3.5 rounded-full text-sm bg-white/20 backdrop-blur-sm border border-white/30 text-white placeholder-white/60 focus:outline-none focus:border-white"
            />
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your@email.com"
              required
              className="flex-1 px-5 py-3.5 rounded-full text-sm bg-white/20 backdrop-blur-sm border border-white/30 text-white placeholder-white/60 focus:outline-none focus:border-white"
            />
            <button
              type="submit"
              disabled={loading}
              className="px-8 py-3.5 rounded-full bg-white text-orange-600 font-bold text-sm hover:shadow-xl transition-all duration-300 hover:scale-105 disabled:opacity-60 cursor-pointer whitespace-nowrap"
            >
              {loading ? <i className="ri-loader-4-line animate-spin"></i> : 'Subscribe'}
            </button>
          </form>
        )}
        {status === 'error' && <p className="text-white/80 text-sm mt-3">{msg}</p>}
      </div>
    </section>
  );
}
